
import Vue from "vue";
import Alerter from "@/components/Alerter.vue";
import { VehiclesService, VehicleSchema } from "@/commons/client";
import { Alert } from "@/commons/types";

export default Vue.extend({
  components: { Alerter },

  props: {
    pk: { type: String, required: true },
  },

  data: () => ({
    alerts: [] as Alert[],
    vehicles: [] as VehicleSchema[],
    searchKey: "",
    loading: false,
    currentPage: 1,
    itemsPerPage: 6,
    advancedFiltersOpen: null as number | null,
    filters: {
      vehicle_id: "",
      plate: "",
    },
  }),

  computed: {
    rules() {
      return this.$store.state.genericRules;
    },
    filteredVehicles(): VehicleSchema[] {
      return this.vehicles.filter((v) => {
        const matchesSearch = this.searchKey
          ? v.vehicle_id
              ?.toLowerCase()
              .includes(this.searchKey.toLowerCase()) ||
            v.plate?.toLowerCase().includes(this.searchKey.toLowerCase())
          : true;

        const matchesId = this.filters.vehicle_id
          ? v.vehicle_id
              ?.toLowerCase()
              .includes(this.filters.vehicle_id.toLowerCase())
          : true;

        const matchesPlate = this.filters.plate
          ? v.plate?.toLowerCase().includes(this.filters.plate.toLowerCase())
          : true;

        return matchesSearch && matchesId && matchesPlate;
      });
    },
    paginatedVehicles(): VehicleSchema[] {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredVehicles.slice(start, start + this.itemsPerPage);
    },
    pageCount(): number {
      return Math.ceil(this.filteredVehicles.length / this.itemsPerPage);
    },
  },

  methods: {
    toggleFilters() {
      this.advancedFiltersOpen = this.advancedFiltersOpen === 0 ? null : 0;
    },
    resetFilters() {
      this.filters = { vehicle_id: "", plate: "" };
      this.searchKey = "";
    },
    formatDate(dateStr: string): string {
      return new Date(dateStr).toLocaleDateString("it-IT");
    },
    async fetchVehicles(): Promise<void> {
      this.loading = true;
      try {
        this.vehicles =
          await VehiclesService.organizationVehiclesListV1OrganizationsPkVehiclesGet(
            parseInt(this.pk),
            undefined,
            100,
            this.searchKey
          );
      } catch (err) {
        this.alerts.push({
          type: "error",
          text: "Errore durante il recupero dei veicoli",
        });
      } finally {
        this.loading = false;
      }
    },
    async search(): Promise<void> {
      this.currentPage = 1;
      await this.fetchVehicles();
    },
  },

  async mounted() {
    await this.fetchVehicles();
  },
});
